import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import Helper from "../../common/Helper";
import { useSeoData } from "../../common/useSeoData";
import AppDataContext from "../../common/AppContext";

export default function HelmetMetaData(props) {
  const { page, url, image, relCanonicalURL, title, teamName, editionName } = props;
  const { leagueName,seasonYear } = useContext(AppDataContext);

  const { keywords, description, hashtag, quote } = useSeoData({
    leagueName,
    page,
    teamName,
    editionName,
    seasonYear
  });

  const currentUrl = encodeURIComponent(Helper.ValidateAndFetchURL(url));

  const seoImage = image !== undefined ? image : "";
  const canonicalURL =
    relCanonicalURL !== undefined ? relCanonicalURL : currentUrl;

  const siteName = `${leagueName} - LockerVision`;
  const twitterDomain = `https://lockervision.${leagueName?.toLowerCase()}.com`;

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="canonical" href={canonicalURL}></link>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="csrf_token" content="" />
      <meta property="type" content="website" />
      <meta property="url" content={currentUrl} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content={seoImage} />
      <meta name="theme-color" content="#ffffff" />
      <meta name="_token" content="" />
      <meta property="title" content={title} />
      <meta property="quote" content={quote} />
      <meta name="description" content={description} />
      <meta property="keywords" content={keywords} />
      <meta property="image" content={seoImage} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:quote" content={quote} />
      <meta property="og:hashtag" content={hashtag} />
      <meta property="og:image" content={seoImage} />
      <meta content="image/*" property="og:image:type" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:description" content={description} />
      <meta name="twitter:card" content={seoImage} />
      <meta name="twitter:site" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:creator" content={hashtag} />
      <meta name="twitter:image" content={seoImage} />
      <meta name="twitter:domain" content={twitterDomain} />
    </Helmet>
  );
}